import React, { useState, useContext, useEffect } from "react";
import { ethers } from "ethers";
import { appContext } from "../App";
import logo from "../assets/images/logo.png";
import gif from '../assets/images/nfts.gif';
import polygonIcon from '../assets/images/polygon-icon.webp'
import songbirdIcon from '../assets/images/songbird-alt.svg'
import { useAccount, useSigner } from "wagmi";
import contractABI from '../assets/abi.json'
import { Spinner, Toast, ToastContainer } from "react-bootstrap";

const MintPage = () => {

  const [showNFTs, setShowNFTs] = useState(false)
  const [mintAmount, setMintAmount] = useState(1);
  const [mintedNFTs, setMintedNFTs] = useState()
  const [canMint, setCanMint] = useState(false)
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState("Loading...")
  const [warning, setWarning] = useState("")
  const url = 'https://brown-hilarious-galliform-710.mypinata.cloud/ipfs/'
  const cid = 'QmNj51eBLZUzys4UVjamLfhXEknLMKN9CeXSjFPhFYNbPL/'
  const [balance, setBalance] = useState(-1)
  const [showToast, setShowToast] = useState(false)

  const [isWhitelisted, setIswhitelisted] = useState(false)
  const [isWhiteListOnly, setIswhitelistOnly] = useState(false)

  const { address } = useAccount()

  const { data: signer, isFetched } = useSigner({
    onSuccess() {
      console.log('signer onSuccess')
    }
  })

  // deployment
  // const rpcURL = "https://polygon-mumbai.blockpi.network/v1/rpc/public";
  // prod
  const rpcURL = "https://sgb.ftso.com.au/ext/bc/C/rpc";

  const [price,setPrice] = useState('...')
  const totalSupply = 2500

  const [
    contractAddress,
    saleComplete, setSaleComplete
  ] = useContext(appContext);

  useEffect(() => {
    if (isFetched) {
      async function getPrice() {
        const contract = new ethers.Contract(
          contractAddress,
          contractABI,
          new ethers.providers.getDefaultProvider(
            rpcURL
          )
        );
        var price = parseInt(ethers.utils.formatEther(await contract.basePrice()))
        console.log('price',price)
        setPrice(price)
        return price
      }
      async function getTotalSupply() {
        const contract = new ethers.Contract(
          contractAddress,
          contractABI,
          new ethers.providers.getDefaultProvider(
            rpcURL
          )
        );
        try {
          const response = (await contract.totalSupply()).toString();
          if (response > totalSupply) {
            setSaleComplete(true);
          }
          else {
            setSaleComplete(false)
          }
          console.log(response);
        } catch (err) {
          console.log(err);
        }
      }
      async function mintCheck(price) {
        var balance = ethers.utils.formatEther(await signer.getBalance())
        setBalance(balance)
        if (parseFloat(balance) < price) {
          setWarning("Low Balance")
          setCanMint(false)
        }
        else {
          setCanMint(true)
        }
      }
      async function isWhitelisted() {
        var contract = new ethers.Contract(contractAddress, contractABI, new ethers.providers.getDefaultProvider(
          rpcURL
        ))
        try {
          var res = await contract.isWhitelisted(address)
        }
        catch {
          console.log("failed to read contract!")
        }
        console.log(res)
        setIswhitelisted(res)
      }
      async function isWhitelistOnly() {
        var contract = new ethers.Contract(contractAddress, contractABI, new ethers.providers.getDefaultProvider(
          rpcURL
        ))
        try {
          var res = await contract.whitelistOnly()
        }
        catch {
          console.log("failed to read contract!")
        }
        console.log(res)
        setIswhitelistOnly(res)
      }
      async function loadSequence() {
        await getTotalSupply()
        await isWhitelisted()
        await isWhitelistOnly()
        let price = await getPrice()
        await mintCheck(price)
        setLoading(false)
      }
      if (balance < 0) {
        loadSequence()
      }
    }
    return () => {

    }
  }, [isFetched, showNFTs]);

  function quantityClick(bool) {
    var amount = mintAmount
    if (bool) {
      amount += 1
      setMintAmount(amount)
    }
    else {
      amount -= 1
      setMintAmount(amount)
    }
    if (parseFloat(balance) < price * (amount)) {
      setWarning("Low Balance")
      setCanMint(false)
    }
    else {
      setWarning('')
      setCanMint(true)
    }
  }

  async function getMintedNFTsImage(mintedID, mintedCount) {
    var nftArray = []
    await setTimeout(1000);
    for (var i = mintedID; i < mintedID + mintedCount; i++) {
      nftArray.push(i)
    }
    setShowNFTs(true);
    console.log(nftArray)
    setMintedNFTs(nftArray);
    setLoading(false);
  }

  async function getMintedID() {
    const contract = new ethers.Contract(
      contractAddress,
      contractABI,
      signer
    );
    try {
      const response = parseInt((await contract.totalSupply()).toString()) + 1;
      return response;
    } catch (err) {
      console.log(err);
    }
  }

  const MintFunction = async () => {
    console.log(canMint, saleComplete)
    if ((saleComplete | !canMint) && !isWhitelisted) {
      return
    }
    else if ((saleComplete == false && canMint == true)|isWhitelisted) {
      setLoading(true);
      setMessage("Minting...!");
      var mintedID = await getMintedID()
      const contract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );
      if (!isWhitelisted) {
        try {
          var value = mintAmount * price
          value = Math.round(value * 1000) / 1000
          value = ethers.utils.parseEther(value.toString())
          console.log(value.toString())
          const response = await contract.mintBatch(mintAmount, { value: value });
          const tx = await response.wait()
          if (tx['status'] === 1) {
            setMessage("Mint Success!")
            setShowToast(true);
            getMintedNFTsImage(mintedID, mintAmount)
          }
          else{
            setMessage('Transaction Failed!');
            setShowToast(true);
            resetLoading();
          }
        }
        catch (err) {
          console.log(err);
          setMessage('Failed!');
          setShowToast(true);
          resetLoading();
        }
      }
      else{
        try{
          var res = await contract.mintWhitelist()
          var tx = await res.wait()
          if(tx['status']===1){
            setMessage("Mint Success!")
            setShowToast(true);
            getMintedNFTsImage(mintedID, mintAmount)
          }
          else{
            setMessage('Transaction Failed!');
            setShowToast(true);
            resetLoading();
          }
        }
        catch(err){
          if(err.code===4001){
          setMessage('Failed!');
          setShowToast(true);
          resetLoading();
          }
          else{
            setMessage('Transaction Denied!');
            setShowToast(true);
            resetLoading();
          }
        }
      }
    }
  }

  async function resetLoading() {
    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }

  function resetFromNFTDisplay() {
    setLoading(true)
    //refetch balance
    setBalance(-1);
    setShowNFTs(false);
    setMintedNFTs([]);

  }

  return (
    <>
      <div className="Container">
        <ToastContainer className="p-3" position="top-center">
          <Toast v onClose={() => { setShowToast(false) }} show={showToast} delay={3000} autohide>
            <Toast.Body>
              {message}
            </Toast.Body>
          </Toast>
        </ToastContainer>
        <div className="transparentBox">
          {!loading && !isWhitelisted && !isWhiteListOnly && !showNFTs ?
            <>
              <h6 className="fade-in" style={{ position: 'absolute', right: '5px', bottom: '98px' }}>{Math.round((mintAmount * price) * 10000) / 10000} <img className="TokenIcon" src={songbirdIcon} /></h6>
              <h6 className="fade-in" style={{ position: 'absolute', bottom: '1px', right: '0px', fontSize: 'small' }}>{price} <img className="TokenIcon" src={songbirdIcon} /> / NFT</h6>
            </>
            : <></>
          }
          <div className="logoDiv">
            <img width={55} height={55} style={{ marginLeft: "-25px", marginRight: '5px' }} src={logo} />
            <h4>Citizens Of Gokubi</h4>
            <h6 style={{ position: 'absolute', bottom: '-4px' }} className="altfont">NFT Collection</h6>
          </div>
          <div style={{ width: '100%', height: '100%' }}>
            {loading ?
              <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spinner animation="border" role="status" />
              </div>
              :
              <>
                {!showNFTs ?
                  <div className="fade-in notLogoDiv">
                    <div className="gifDiv">
                      <img className="nftsGif" width={200} height={205} src={gif} />
                      <h1 className="nftsGifText">?</h1>
                    </div>
                    {!isWhitelisted && !isWhiteListOnly ?
                      <div className="mintBtnDiv">

                        <button className="mintBtn"
                          style={{ backgroundColor: '#E74646', border: '0', color: 'white', borderRadius: '30px', width: '40px' }}
                          onClick={() => {
                            {
                              mintAmount > 1 ? quantityClick(false) : <></>;
                            }
                          }}
                        >
                          -
                        </button>
                        <button className="mintBtn" style={{ color: 'white', background: 'transparent', width: '50px', marginLeft: '25px', border: '2px solid white', marginRight: '25px', borderRadius: '30px' }}>
                          {mintAmount}
                        </button>
                        <button className="mintBtn"
                          style={{ backgroundColor: '#59CE8F', border: '0', width: '40px', color: 'white', borderRadius: '30px' }}
                          onClick={() => {
                            {
                              mintAmount < 4 ? quantityClick(true) : <></>;
                            }
                          }}
                        >
                          +
                        </button>
                        <div style={{ marginTop: '30px' }}>
                          <button id='mintBTN' onClick={MintFunction} className="mintBtn">{loading ? "..." : !saleComplete ? canMint ? "MINT!" : warning : "SOLD OUT!"}</button>
                        </div>
                        {/* <h5 id='warning' style={{ position: 'absolute', bottom: '-30px', right: '-95px', color: 'orange' }}>{warning}</h5> */}
                      </div> :
                      <>
                      {isWhitelisted?
                      <div>
                        <h6>
                          You Are Whitelisted Avail A Free Mint!
                        </h6>
                        <br />
                        <div>
                          <button id='mintBTN' onClick={MintFunction} className="mintBtn">{"FREE MINT!"}</button>
                        </div>
                      </div>:
                      <h5>You are not whitelisted! Try again when minting is live for everyone :)</h5>
                      }
                      </>
                    }

                  </div> :

                  <div className="nftBox fade-in">
                    <h4 className="nftText">Minted NFTs!</h4>
                    <div className="nftImagesDiv">
                      {mintedNFTs.map(element => {
                        return (<img className="nftImage" src={url + cid + element + '.png'} />);
                      })}
                    </div>
                    <div className="nftBackBtnDiv">
                      <button onClick={() => {
                        resetFromNFTDisplay()
                      }} className="buttonBlue">Mint More!</button>
                    </div>

                  </div>


                }
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default MintPage;
